/**
 * datatype-select
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default sb => {
    let datatype;

    const onDatatypeSelectionChange = function onDatatypeSelectionChange() {
        sb.notify({
            type: "datatypeSelectionChanged",
            data: [].map.call(
                getSelectedOptions(datatype[0]),
                option => option.value
            )
        });
    };

    return {
        init() {
            datatype = sb.find("#data_type");
            sb.addEvent(datatype, "change", onDatatypeSelectionChange);
        },
        destroy() {
            sb.removeEvent(datatype, "change", onDatatypeSelectionChange);
            datatype = null;
        }
    }
}